<!--
  items-entry.component.html

  The check-off, then the way to record something that was not on the PO. Order is
  not incidental: the PO's own lines are what the delivery is checked against, and
  an off-PO addition is the exception you reach for once they are dealt with.
-->
<app-line-item-checkoff
  [rows]="rows"
  [damageByLine]="damageByLine"
  [isLegacyPo]="isLegacyPo"
  [expandedIndices]="expandedIndices"
  [isLineReadOnly]="isLineReadOnly"
  [readOnlyNote]="readOnlyNote"
  [allowClearStatus]="allowClearStatus"
  [allowOffPoQtyEdit]="allowOffPoQtyEdit"
  [allowOffPoRemove]="allowOffPoRemove"
  [linePanel]="linePanel"
  [errorAtIndex]="errorAtIndex"
  [errorText]="errorText"
  (rowsChange)="rowsChange.emit($event)"
  (statusCleared)="statusCleared.emit($event)"
  (rowRemoved)="rowRemoved.emit($event)"
  (expandedChange)="expandedChange.emit($event)"
></app-line-item-checkoff>

<!-- Additional items (§5): something received that wasn't on the PO. Collapsed to a
     single button until wanted, because on most deliveries there is nothing to add
     and an open form reads as a field waiting to be filled. -->
<ng-container *ngIf="allowAddOffPo">
  <button type="button" *ngIf="!showAddForm" class="iae-add-btn" (click)="toggleAddForm()">
    <ion-icon name="add-circle-outline"></ion-icon>
    Custom Add In
  </button>

  <div *ngIf="showAddForm" class="iae-add-form">
    <input class="iae-desc-input"
           type="text"
           autocapitalize="characters"
           placeholder="Additional items, corrections, etc."
           aria-label="Description of the additional item"
           [(ngModel)]="newItemDescription"
           (input)="newItemDescription = newItemDescription.toUpperCase()" />
    <div class="iae-add-form-row">
      <!-- type="text" (not "number"): Angular's number value accessor would turn the
           bound model into a number/null, and holding it as a string is what lets a
           blank be told from a zero. inputmode shows the numeric keypad on mobile;
           the (ngModelChange) strip is what stops text on desktop, where inputmode
           is a no-op. -->
      <input class="iae-qty-input"
             type="text" inputmode="numeric"
             placeholder="Qty (optional)"
             aria-label="Quantity of the additional item"
             [(ngModel)]="newItemQty"
             (ngModelChange)="onQtyInput()" />
      <button type="button" class="iae-cancel-btn" (click)="toggleAddForm()">Cancel</button>
      <button type="button" class="iae-save-btn" [disabled]="!canAdd" (click)="addItem()">Add</button>
    </div>
  </div>
</ng-container>
